import * as cx from 'classnames';
import range from 'lodash-es/range';
import truncate from 'lodash-es/truncate';
import { WIKI_EXP_HOMEPAGE_TITLE } from 'mk/autogenerated/translations/WikiExperiences.933454e7c74e5139752b8cea31068d12'
import { ExperienceEntity } from 'mk2/apps/wiki/schemas';
import { wikiArticleUrl } from 'mk2/apps/wiki/utils';
import LinkListItem, { GrowPriority, LinkListItemPlaceholder } from 'mk2/components/LinkListItem';
import Panel from 'mk2/components/Panel';
import PanelHeading from 'mk2/components/PanelHeading';
import * as React from 'react';
import styles from './WikiExperiences.mscss';

interface OwnProps {
    className?: string;
    experiences: ExperienceEntity[];
}

type Props = OwnProps;

const WikiExperiences: React.StatelessComponent<Props> = ({ className, experiences }) => (
    <Panel className={cx(styles.WikiExperiences, className)}>
        <PanelHeading title={WIKI_EXP_HOMEPAGE_TITLE} />

        <ul className={styles.WikiExperiences__list}>
            {experiences.map((exp, index) => (
                <LinkListItem
                    key={exp.id}
                    to={wikiArticleUrl(exp.article, `experience-${exp.id}`)}
                    title={exp.article.title}
                    priority={GrowPriority.title}
                >
                    - &ldquo;{truncate(exp.text, { length: 120 })}&bdquo;
                </LinkListItem>
            ))}
        </ul>
    </Panel>
);

WikiExperiences.displayName = 'WikiExperiences';

export default WikiExperiences;

interface PlaceholderOwnProps {
    className?: string;
    length?: number;
}

export const WikiExperiencesPlaceholder: React.StatelessComponent<PlaceholderOwnProps> = ({ className, length = 6 }) => (
    <Panel className={cx(styles.WikiExperiences, className)}>
        <PanelHeading title={WIKI_EXP_HOMEPAGE_TITLE} />

        <ul className={styles.WikiExperiences__list}>
            {range(length).map((idx) => (
                <LinkListItemPlaceholder key={idx} width={`${ [90, 85, 80, 70, 75, 85][idx % 6] }%`} />
            ))}
        </ul>
    </Panel>
);
